import React, { useState, useRef } from 'react';
import { Button, Col, Row, Modal, Space, Input, Form } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { GoogleMap, LoadScript, Marker, DirectionsService, DirectionsRenderer, Autocomplete } from '@react-google-maps/api';

const containerStyle = {
	width: '100%',
	height: '400px'
};

const defaultCoordinates = {
	lat: 22.3235253,
	lng: 114.1805002
};

const ModalMap = props => {
	const [form] = Form.useForm();

	const [map, setMap] = useState(null);
	const [address, setAddress] = useState('');
	const [autocomplete, setAutocomplete] = useState(null);
	const [centerCoordinates, setCenterCoordinates] = useState(defaultCoordinates);

	const { currentMarked, setCurrentMarked, selectedAddress, setSelectedAddress, handleConfirm, loadingSubmit } = props;

	const onUnmount = React.useCallback(function callback(map) {
		setMap(null);
	}, []);

	const handleMapClick = async e => {
		try {
			const pointedAddress = await handleGetAddress({ lat: e.latLng.lat(), lng: e.latLng.lng() });
			setCurrentMarked({ lat: e.latLng.lat(), lng: e.latLng.lng() });
			setSelectedAddress(pointedAddress);
		} catch (error) {

		}
	};

	const handleGetAddress = currentMarked => {
		return new Promise((resolve, reject) => {
			if (currentMarked) {
				const geocoder = new window.google.maps.Geocoder();
				geocoder.geocode({ location: currentMarked }, (results, status) => {
					if (status === 'OK') {
						if (results[0]) {
							const address = results[0].formatted_address.toLowerCase();
							if (address.includes('hong kong') || address.includes('hongkong') || address.includes('china')) {
								resolve(results[0].formatted_address);
							} else {
								const errorMessage = 'Address is not inside Hong Kong or China';
								props.alert.show(errorMessage, { type: 'error' });
								reject(errorMessage);
							}
						} else {
							props.alert.show('No results found', { type: 'error' });
							reject('No results found');
						}
					} else {
						const errorMessage = `Geocoder failed due to: ${status}`;
						props.alert.show(errorMessage, { type: 'error' });
						reject(errorMessage);
					}
				});
			} else {
				resolve(null);
			}
		});
	};
	const handlePlaceChanged = () => {
		if (autocomplete) {
			const place = autocomplete.getPlace();
			const exactInput = document.querySelector('.pac-target-input')?.value;
			if (place.geometry && place.geometry.location) {
				const location = place.geometry.location;
				const address = exactInput || place.formatted_address || place.name;
				setCurrentMarked({ lat: location.lat(), lng: location.lng() });
				setSelectedAddress(address);
				setCenterCoordinates({ lat: location.lat(), lng: location.lng() });
				setAddress(address);
				map.setCenter(location);
			}
		}
	};

	const onLoadAutocomplete = (autocompleteInstance) => {
		setAutocomplete(autocompleteInstance);

		if (map) {
			const mapCenter = map.getCenter();
			const bounds = {
				north: mapCenter.lat() + 0.2,
				south: mapCenter.lat() - 0.2,
				east: mapCenter.lng() + 0.2,
				west: mapCenter.lng() - 0.2
			};

			autocompleteInstance.setBounds(bounds);
		}
	};



	const onMapIdle = () => {
		if (map && autocomplete) {
			const mapCenter = map.getCenter();
			const bounds = {
				north: mapCenter.lat() + 0.2,
				south: mapCenter.lat() - 0.2,
				east: mapCenter.lng() + 0.2,
				west: mapCenter.lng() - 0.2
			};

			autocomplete.setBounds(bounds); // Update bounds when the map moves
		}
	};

	return (
		<>
			<Modal
				title={
					<>
						<Row>
							<Col
								xs={{ span: 22, offset: 1 }}
								sm={{ span: 22, offset: 1 }}
								md={{ span: 22, offset: 1 }}
								lg={{ span: 22, offset: 1 }}
								xl={{ span: 22, offset: 1 }}
							>
								Favorite Location
							</Col>
						</Row>
					</>
				}
				footer={null}
				destroyOnClose={true}
				onCancel={e => {
					form.setFieldsValue({ address: null });
					props.setIsModalMapOpen(false);
					setCurrentMarked(null);
					setSelectedAddress(null);
					setAddress(null);
					setAutocomplete(null);
					setCenterCoordinates(defaultCoordinates);
				}}
				open={props.isModalMapOpen}
				width={props.windowSize < 992 ? '80%' : '50%'}
			>
				<>
					<Row>
						<Col
							xs={{ span: 22, offset: 1 }}
							sm={{ span: 22, offset: 1 }}
							md={{ span: 22, offset: 1 }}
							lg={{ span: 22, offset: 1 }}
							xl={{ span: 22, offset: 1 }}
						>
							<Form
								form={form}
								layout="vertical"
							>
								<div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end' }}>
									<Form.Item
										label="Destination Name"
										name="address"
										style={{ flex: 1, marginBottom: 0 }}
									>
										<Autocomplete
											onLoad={onLoadAutocomplete}
											onPlaceChanged={handlePlaceChanged}
										>
											<Input
												placeholder="Full Address of Destination"
												value={address}
												onChange={(e) => setAddress(e.target.value)}
											/>
										</Autocomplete>

									</Form.Item>
								</div>
							</Form>
							{props.isLoaded ? (
								<GoogleMap
									mapContainerStyle={{ width: '100%', height: '450px', marginTop: 10 }}
									// center={{
									// 	lat: currentMarked ? currentMarked.lat : 22.3235253,
									// 	lng: currentMarked ? currentMarked.lng : 114.1805002
									// }} // Default center
									center={centerCoordinates}
									zoom={18}
									onClick={handleMapClick}
									onLoad={map => {
										setMap(map);
									}}
									onUnmount={onUnmount}
									onIdle={onMapIdle}
								>
									{currentMarked && <Marker position={{ lat: currentMarked.lat, lng: currentMarked.lng }} />}
								</GoogleMap>
							) : (
								<></>
							)}

							<div style={{ marginTop: 19, display: 'flex', justifyContent: 'end' }}>
								<Space>
									<Button
										onClick={() => {
											form.setFieldsValue({ address: null });
											setCurrentMarked(null);
											setSelectedAddress(null);
											props.setIsModalMapOpen(false);
											setAddress(null);
											setAutocomplete(null);
											setCenterCoordinates(defaultCoordinates);
										}}
										loading={loadingSubmit}
									>
										Cancel
									</Button>
									<Button
										type="primary"
										onClick={() => {
											handleConfirm();
											setAddress(null);
											setAutocomplete(null);
											setCenterCoordinates(defaultCoordinates);
										}}
										loading={loadingSubmit}
										disabled={!selectedAddress && !currentMarked}
									>
										Confirm
									</Button>
								</Space>
							</div>
						</Col>
					</Row>
				</>
			</Modal>
		</>
	);
};

export default ModalMap;
